import React, { Component } from 'react'
import intl from 'react-intl-universal'
import PropTypes from 'prop-types'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import { parse } from 'query-string'
import Page from './Page'

@inject('user')
@observer
class LoginSuccessPage extends Component {
  render () {
    const { token } = parse(this.props.location.search.substr(1))
    if (token) {
      this.props.user.setToken(token)
      this.props.history.push('/')
    }
    return (
      <Page title='Information'>
        <article className='b-info'>
          <h2 className='b-info-title'>{intl.get('Login success')}</h2>
        </article>
      </Page>
    )
  }
}

LoginSuccessPage.propTypes = {
  history: PropTypes.any,
  location: MobxPropTypes.objectOrObservableObject,
  user: MobxPropTypes.observableObject
}

export default LoginSuccessPage



// WEBPACK FOOTER //
// ./src/containers/LoginSuccessPage.js